module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("My prison is the universe,")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("a maze of stars my cage.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("I bear an unremitting curse:")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("my prison is the universe.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("No mercy may my doom reverse")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("nor pleas my plight assuage.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("My prison is the universe—")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("a maze of stars, my cage")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c74857a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section2.vue
// module id = 69
// module chunks = 0